<template>
  <div id="login">
    <h2 class="role">{{ userProfile.role }}'s Workbench</h2>


<span v-if="this.userProfile.role == 'Maint. Manager' " class="p-overlay-badge">
    <Button type="button" class="newbutton p-button-raised p-button-rounded p-mr-3" >
      <router-link to="/newfaults" class="p-overlay-badge">New Faults Reported</router-link>
    </Button>
    <span v-show="notassigned.length > 0" class="p-badge p-badge-danger p-mr-5">{{ notassigned.length }}</span>
</span>

<span v-if="this.userProfile.role == 'Maint. Manager' " class="p-overlay-badge">
    <Button type="button" class="verbutton p-button-raised p-button-rounded" >
      <router-link to="/verifiedfaults" class="p-overlay-badge">Faults Verified by a Mechanic</router-link>
    </Button>
    <span v-show="verified.length > 0" class="p-badge p-badge-danger p-mr-3">{{ verified.length}}</span>
</span>

<br/><br/>

<span class="p-overlay-badge">
    <Button type="button" class="workbutton p-button-raised p-button-rounded" >
      <router-link to="/assigned" class="p-overlay-badge">My Assigned Work</router-link>
    </Button>
    <span v-show="assigned.length > 0" class="p-badge p-badge-info p-mr-3">{{ assigned.length}}</span>
</span>

<br/><br/>

<!-- <span class="p-overlay-badge">
    <Button type="button" class="toolbutton p-button-raised p-button-rounded p-mr-3" >
      <router-link to="/toolroom" class="p-overlay-badge">Tools Not Returned</router-link>
    </Button>
    <span v-show="verified.length > 0" class="p-badge p-badge-danger p-mr-5">{{ verified.length}}</span>
</span>

<span class="p-overlay-badge">
    <Button type="button" class="toolbutton p-button-raised p-button-rounded" >
      <router-link to="/toolroom" class="p-overlay-badge">Overdue Calibrations</router-link>
    </Button>
    <span v-show="verified.length > 0" class="p-badge p-badge-danger p-mr-3">{{ verified.length}}</span>
</span> -->


          <br/><br/>
  </div>
</template>
<script>
import { fb_db, fs, fb_faults, fb_users, fb_auth } from "../firebase";
import router from "../router";
import Button from 'primevue/button';

export default {
  name: "RoleLinks",
  props: {
    role: String,
  },
  data() {
    return {
      login: { nickname: "" },
      faults: [],
      notassigned: [],
      assigned: [],
      verified:[],
      approved:[],
    };
  },
 async created() {
    let userData = await fb_users.doc(fb_auth.currentUser.uid).get()
    let user = userData.data();
    const docs = fb_db.collection("faults").where("status", "==", "Not Assigned").where("puic", "==", user.puic)

    this.notassigned = docs.onSnapshot(doc => {
      this.notassigned = []
      doc.forEach(d => {
        let item = d.data()
        item.id = d.id
        // get the user data
        this.notassigned.push(item)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });

    const docs1 = fb_db.collection("faults").where("status", "==", "Assigned")
    .where("puic", "==", user.puic)
    .where("mechanic", "==", fb_users.doc(fb_auth.currentUser.uid))

    this.assigned = docs1.onSnapshot(doc1 => {
      this.assigned = []
      doc1.forEach(d1 => {
        let item1 = d1.data()
        item1.id = d1.id
        // get the user data
        this.assigned.push(item1)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });

    const docs2 = fb_db.collection("faults").where("status", "==", "Verified").where("puic", "==", user.puic)

    this.verified = docs2.onSnapshot(doc2 => {
      this.verified = []
      doc2.forEach(d2 => {
        let item2 = d2.data()
        item2.id = d2.id
        // get the user data
        this.verified.push(item2)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });
        const docs3 = fb_db.collection("users").where("approved", "==", false)

    this.approved = docs3.onSnapshot(doc3 => {
      this.approved = []
      doc3.forEach(d3 => {
        let item3 = d3.data()
        item3.id = d3.id
        // get the user data
        this.approved.push(item3)
      });
    }, err => {
      console.log(`Encountered error: ${err}`);
    });
  },
  // destroyed () {
  //   this.notassigned();
  // },
  // async mounted() {
  //   await this.getFaults();
  // },
  methods: {
    closeMenu() {
      this.$emit("menuclicked");
    },
    loginChat(evt) {
      evt.preventDefault();

      router.push({
        name: "RoomList",
        params: { nickname: this.userProfile.lastname },
      });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;
}

.newbutton {
  background-color: white;
  border-color: red;
  padding: 10px;
  height: 100px;
  width: 120px;
}
.workbutton {
  background-color: white;
  border-color: #749df5;
  padding: 10px;
  height: 100px;
  width: 120px;
}
.verbutton {
  background-color: white;
  padding: 10px;
  height: 100px;
  width: 120px;
}
.toolbutton {
  background-color: white;
  border-color: #000000;
  padding: 10px;
  height: 100px;
  width: 120px;
}

.p-overlay-badge{
  color: black;
}

</style>